<div mat-dialog-title class="dialog-header">
    <span
        class="x-circle"
        hamIconShapes
        icon="assets/hamIcons/x-circle.svg"
        [variant]="'transparent'"
        [size]="'lg'"
        (click)="closeDialog()"
    ></span>
</div>

<div class="dialog-content">
    <!-- #createForm -->
    <ng-container *ngIf="options">
        <aumico-form [options]="options" [delegate]="formDelegate" [data]="data.fliToEdit"> </aumico-form>
    </ng-container>
</div>
